module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/bern-de-fc1a5058541422fe8888ff79d14f52d2.png";